<template>
  <router-view/>
</template>

<script>
export default {
  name: "SyncAuthorization",
  mounted() {
    this.sendParameters();
  },
  methods: {
    sendParameters() {
      let key = Number(this.$route.query.key);
      let email= this.$route.query.email;
      let allow = (this.$route.query.allow === 'true');

      // eslint-disable-next-line no-console
      console.log(allow);
      if(key !== undefined && email !== undefined && allow !== undefined) {
        this.$router.push({
          name: 'sync-authorization-request',
          params: { key: key, email: email, allow: allow, },
        });
      }
      else
        alert(this.$t('alertNotParameters'));
    },
  }
}
</script>



<style scoped>

</style>
